<div id="button" class="ion-activatable" [ngStyle]="buttonStyle">
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 50">
    <circle
      r="25"
      cx="25"
      cy="25"
      stroke-width="3"
      [attr.fill]="svgFill"
      [attr.stroke]="svgStroke"
    ></circle>
  </svg>
  <ion-icon *ngIf="ionIcon" [name]="ionIcon" [ngStyle]="iconStyle"></ion-icon>
  <ion-icon *ngIf="svgIcon" [src]="svgIconSrc" [ngStyle]="iconStyle"></ion-icon>
  <ion-ripple-effect></ion-ripple-effect>
</div>
<span *ngIf="label">{{ label }}</span>
